var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "step" },
      [
        _c(
          "el-steps",
          { attrs: { active: _vm.active, "align-center": "" } },
          _vm._l(_vm.step, function(step, index) {
            return _c("el-step", {
              key: index,
              attrs: { description: step.desc }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form_content" },
      [
        _c(
          "transition",
          { attrs: { name: "fade01", mode: "out-in" } },
          [
            _c("router-view", {
              on: {
                page: function($event) {
                  return _vm.setPage($event)
                },
                transition: function($event) {
                  return _vm.transitionPage($event)
                },
                next: function($event) {
                  return _vm.nextPage($event)
                },
                back: function($event) {
                  return _vm.backPage()
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }